'use strict';
/**
 * A service to get and edit tracked moods on the site
 */

angular.module('msTracker').service('chartJSSvc', [function () {

  var colors = ['#007ca6', '#007ca6', '#007ca6', '#007ca6', '#007ca6', '#007ca6', '#007ca6'];
  var assessmentColors = ['#4CAF50', '#2196F3', '#9C27B0', '#C62828', '#46bfbd', '#FF5722', '#795548'];

  function assessmentOptions() {

    return {
      colors: colors,
      spanGaps: true,
      tooltips: {
        enabled: false
      },
      elements: {
        line: {
          fill: false,
          borderWidth: 4,
          hoverBorderWidth: 4
        },
        point: {
          radius: 8,
          hoverRadius: 8
        }
      },
      scales: {
        xAxes: [{
          type: 'time',
          time: {
            displayFormats: {
              'day': 'MMM D',
              'week': 'MMM D'
            },
            max: moment().endOf('day').add(1, 'second'),
            minUnit: 'day'
          }
        }],
        yAxes: [{
          gridLines: {
            tickMarkLength: 0,
            zeroLineColor: 'rgba(0, 0, 0, 0.1)',
            drawBorder: true
          },
          ticks: {
            reverse: true,
            bodyFontFamily: 'Source Sans Pro',
            min: -10,
            beginAtZero: false,
            suggestedMax: 50,
            callback: function callback() {
              return '';
            }
          }
        }]
      },
      maintainAspectRatio: false,
      animation: {
        duration: 0
      }
    };
  }

  function fullTrackerOptions() {

    return {
      colors: ['#007ca6'],
      spanGaps: true,
      tooltips: {
        enabled: false
      },
      elements: {
        line: {
          fill: true,
          borderWidth: 2,
          tension: .2
        },
        point: {
          radius: 4,
          hoverRadius: 4
        }
      },
      scales: {
        xAxes: [{
          type: 'time',
          gridLines: {
            tickMarkLength: 10,
            zeroLineWidth: 0,
            zeroLineColor: '#fff'
          },
          time: {
            displayFormats: {
              'day': 'MMM D',
              'week': 'MMM D'
            },
            minUnit: 'day'
          }
        }],
        yAxes: [{
          gridLines: {
            tickMarkLength: 0,
            zeroLineColor: 'rgba(0, 0, 0, 0.1)',
            drawBorder: true
          },
          ticks: {
            reverse: false,
            bodyFontFamily: 'Source Sans Pro',
            min: -1,
            max: 1,
            maxTicksLimit: 5,
            padding: 40,
            callback: function callback() {
              return '';
            }
          }
        }]
      },
      maintainAspectRatio: false,
      animation: {
        duration: 0
      }
    };
  }

  function trackerDotStyles(index, size) {
    return {
      'width': size,
      'height': size,
      'background-color': assessmentColors[index]
    };
  }

  function buildChartJSSeries(tracker) {
    var arrayOfTitles = [];
    tracker.forEach(function (tracker) {
      arrayOfTitles.push(tracker.title);
    });
    return arrayOfTitles;
  }

  function createTimeSeriesLabels(trackerData) {
    var chartJSLabels = [];

    if (trackerData && trackerData.length) {
      trackerData[trackerData.length - 1].data.forEach(function (datapoint) {
        chartJSLabels.push(datapoint.datetime);
      });
    }

    return chartJSLabels;
  }

  return {
    buildChartJSSeries: buildChartJSSeries,
    createTimeSeriesLabels: createTimeSeriesLabels,
    assessmentOptions: assessmentOptions,
    fullTrackerOptions: fullTrackerOptions,
    colors: colors,
    assessmentColors: assessmentColors,
    trackerDotStyles: trackerDotStyles
  };
}]);